import { useState } from "react";
import SiteShell from "../components/SiteShell";

function Login() {
  const [authMode, setAuthMode] = useState("login");
  const [showSupport, setShowSupport] = useState(false);

  return (
    <SiteShell route="login" heroHidden={true}>
      <section className="mx-auto min-h-[calc(100vh-220px)] w-full max-w-[1100px] px-4 py-8 md:px-8 lg:py-12">
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_28px_80px_-30px_rgba(15,23,42,0.45)] lg:grid lg:min-h-[620px] lg:grid-cols-2">
          <div className="relative flex flex-col justify-center border-b border-slate-200 bg-[radial-gradient(circle_at_top,#e8f6ff_5%,#f6fbff_55%,#ffffff_100%)] px-6 py-8 sm:px-8 lg:border-b-0 lg:border-r lg:px-12">
            <div className="absolute -left-16 top-14 h-44 w-44 rounded-full bg-[#e37921]/10 blur-3xl" />
            <div className="absolute -bottom-10 right-0 h-40 w-40 rounded-full bg-[#0ea5e9]/10 blur-3xl" />

            <div className="relative">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#e37921]/25 bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#e37921]">
                Secure Access
              </div>
              <h2 className="text-3xl font-bold leading-tight tracking-tight text-[#0f172a] md:text-4xl lg:text-5xl">
                One place for
                <span className="block text-[#e37921]">Loans, KYC and Offers</span>
              </h2>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600 md:text-lg">
                Sign in to continue your journey, track applications and verify
                details in minutes.
              </p>

              <div className="mt-8 grid gap-3 text-sm text-slate-700 md:text-base">
                <p className="rounded-lg border border-slate-200/80 bg-white/75 px-3 py-2">
                  Fast OTP login and profile verification
                </p>
                <p className="rounded-lg border border-slate-200/80 bg-white/75 px-3 py-2">
                  Real-time status updates for each application
                </p>
                <p className="rounded-lg border border-slate-200/80 bg-white/75 px-3 py-2">
                  Dedicated support for onboarding and KYC issues
                </p>
              </div>
            </div>
          </div>

          <div className="relative px-6 py-8 sm:px-8 lg:px-12 lg:py-10">
            <a
              href="#/"
              aria-label="Close login"
              className="absolute right-6 top-4 text-4xl leading-none text-slate-400 transition hover:text-slate-700"
            >
              ×
            </a>

            <div className="mt-8 lg:mt-10">
              <h1 className="text-3xl font-bold tracking-tight text-[#13243d] md:text-4xl">
                {authMode === "login" ? "Welcome back" : "Create your account"}
              </h1>
              <p className="mt-2 text-sm text-slate-600 md:text-base">
                {authMode === "login"
                  ? "Access your profile, KYC status and personalized offers."
                  : "Get started to apply, verify and track your loan journey."}
              </p>
            </div>

            <div className="mt-6 inline-flex w-full rounded-xl border border-slate-200 bg-slate-100/80 p-1">
              <button
                type="button"
                onClick={() => setAuthMode("login")}
                className={`w-1/2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
                  authMode === "login"
                    ? "bg-white text-[#13243d] shadow-sm"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                Login
              </button>
              <button
                type="button"
                onClick={() => setAuthMode("signup")}
                className={`w-1/2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
                  authMode === "signup"
                    ? "bg-white text-[#13243d] shadow-sm"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                Sign Up
              </button>
            </div>

            <form className="mt-6 space-y-4" onSubmit={(event) => event.preventDefault()}>
              <div className="space-y-1.5">
                <label
                  htmlFor="login-identity"
                  className="block text-sm font-medium text-slate-700"
                >
                  Mobile Number or PAN
                </label>
                <input
                  id="login-identity"
                  type="text"
                  placeholder="Enter mobile number or PAN"
                  className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-[#e37921] focus:ring-2 focus:ring-[#e37921]/15"
                />
              </div>

              {authMode === "signup" ? (
                <div className="space-y-1.5">
                  <label
                    htmlFor="login-full-name"
                    className="block text-sm font-medium text-slate-700"
                  >
                    Full Name
                  </label>
                  <input
                    id="login-full-name"
                    type="text"
                    placeholder="Enter full name"
                    className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-[#e37921] focus:ring-2 focus:ring-[#e37921]/15"
                  />
                </div>
              ) : null}

              <button
                type="submit"
                className="w-full rounded-lg bg-[#e37921] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#e37921]"
              >
                {authMode === "login" ? "Send OTP" : "Create Account"}
              </button>
            </form>

            <p className="mt-5 text-center text-sm text-slate-600">
              {authMode === "login" ? "New on Finn Cube?" : "Already have an account?"}{" "}
              <button
                type="button"
                className="font-semibold text-[#e37921]"
                onClick={() =>
                  setAuthMode(authMode === "login" ? "signup" : "login")
                }
              >
                {authMode === "login" ? "Sign Up" : "Login"}
              </button>
            </p>

            <p className="mx-auto mt-3 max-w-xl text-center text-xs leading-relaxed text-slate-500 md:text-sm">
              By continuing, you agree to our{" "}
              <a
                href="#/terms-and-conditions"
                className="font-medium text-slate-700 underline"
              >
                Terms and Conditions
              </a>{" "}
              and{" "}
              <a
                href="#/privacy-policy"
                className="font-medium text-slate-700 underline"
              >
                Privacy Policy
              </a>
              and recieve communication via SMS, E-Mail and WhatsApp..
            </p>
            <div className="mt-3 text-center">
              <button
                type="button"
                className="text-sm font-semibold text-[#e37921] transition hover:text-[#e37921] md:text-base"
                onClick={() => setShowSupport((previous) => !previous)}
              >
                Need help? Contact Support
              </button>
            </div>

            {showSupport ? (
              <div className="mx-auto mt-3 max-w-xl rounded-xl border border-[#e37921]/25 bg-[#fff5f4] px-4 py-3 text-center">
                <p className="text-sm font-medium text-slate-700">
                  Mobile: <span className="font-semibold">9217339057</span>
                </p>
                <p className="mt-1 text-sm font-medium text-slate-700">
                  Email: <span className="font-semibold">care@finncube.com</span>
                </p>
                <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:justify-center">
                  <a
                    href="tel:+919217339057"
                    className="rounded-lg bg-[#e37921] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#e37921]"
                  >
                    Call
                  </a>
                  <a
                    href="mailto:care@finncube.com"
                    className="rounded-lg border border-[#e37921] px-4 py-2 text-sm font-semibold text-[#e37921] transition hover:bg-[#e37921]/10"
                  >
                    Send Email
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default Login;
